import { Component, OnInit } from '@angular/core';
import { 
    
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { DataService } from '@app/services';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        TranslatePipe
    ]
})
export class FooterComponent  implements OnInit {
    
    currentYear: string
    
    constructor(    
        public dataService: DataService
    ) {}

    ngOnInit() {
        this.currentYear = moment().format('YYYY');
    }
    
}
